import React from 'react';
import Popup from 'reactjs-popup';

import css from '../../css/common/myPopup.module.scss';
import { ReactComponent as Cross } from '../../img/common/cross.svg';

type MyPopupProps = {
    trigger: JSX.Element;
    title: string;
    content: JSX.Element;
};

export const MyPopup: React.FC<MyPopupProps> = (props) => (
    <Popup trigger={props.trigger} modal nested overlayStyle={{ background: 'rgba(0, 0, 0, 0.7)' }}>
        {(close: () => void) => (
            <div className={css.popup}>
                <div className={css.title}>
                    {props.title}
                    <Cross height={24} width={24} onClick={close} role="img" aria-label="閉じる" />
                </div>
                <div className={css.content}>{props.content}</div>
            </div>
        )}
    </Popup>
);
